import React from "react";
import { IconZoomCodeFilled } from "@tabler/icons-react";
import { Button, cn } from "visuais";

interface ShineButtonProps {
  /** Texto do botão */
  label?: string;
  /** Ícone personalizado (opcional) */
  buttonIcon?: React.ReactNode;
  /** Tamanho do botão */
  size?: "default" | "sm" | "lg" | "icon";
  /** Variante do botão */
  variant?:
    | "default"
    | "destructive"
    | "outline"
    | "secondary"
    | "ghost"
    | "link";
  /** Estado desabilitado */
  disabled?: boolean;
  /** Função de clique */
  onClick?: () => void;
  /** Classes CSS adicionais */
  className?: string;
  /** Mostrar efeito de brilho */
  showShineEffect?: boolean;
  /** Mostrar label do botão */
  showLabel?: boolean;
  /** Título do botão */
  title?: string;
  /** Label para acessibilidade */
  "aria-label"?: string;
  /** Tipo do botão */
  type?: "button" | "submit" | "reset";
}

const ShineButton: React.FC<ShineButtonProps> = ({
  label = "Conectar Produto do Protheus",
  buttonIcon,
  size = "default",
  variant = "outline",
  disabled = false,
  onClick,
  className,
  showShineEffect = true,
  showLabel = true,
  title = "Buscar Produto",
  "aria-label": ariaLabel,
  type = "button",
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <Button
      type={type}
      size={size}
      variant={variant}
      onClick={handleClick}
      disabled={disabled}
      title={title}
      className={cn("group relative overflow-hidden", className)}
      aria-label={ariaLabel || label}
    >
      {/* Shine effect - controlado por showShineEffect */}
      {showShineEffect && (
        <div className="absolute inset-0 -top-1 -left-1 bg-gradient-to-r from-transparent via-white/30 to-transparent skew-x-12 translate-x-[-100%] group-hover:translate-x-[200%] transition-transform duration-1000 ease-out" />
      )}

      {/* Content */}
      <div className="relative flex items-center gap-2">
        {buttonIcon || <IconZoomCodeFilled className="h-4 w-4" />}
        {showLabel && <span className="tracking-wide">{label}</span>}
      </div>
    </Button>
  );
};

export default ShineButton;
